<template>
  <div id="map" class="map" style="height:100%;width:100%"></div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions } from "vuex";

export default {
  name: "Map",
  data() {
    return {
      viewer: null,
      mapZoom: 4
    };
  },
  props: {
    name: {
      type: String,
      required: true
    },
    farmId: {
      type: Number,
      required: false,
      default: 0
    }
  },
  mounted: function() {
    this.initMap(this.farmId);

    this.listener = event => {
      const canvas = document.querySelector("canvas");
      const rect = canvas.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;

      this.$emit("coordinates", { x: x, y: y });
    };
    setTimeout(() => {
      const canvas = document.querySelector("canvas");
      canvas.addEventListener("mousedown", this.listener);
    });
  },
  beforeDestroy() {
    const canvas = document.querySelector("canvas");
    if (canvas) {
      canvas.removeEventListener("mousedown", this.listener);
    }
  },
  computed: { ...mapState({}) },
  methods: {
    initMap(id) {
      if (id == 0) {
        id = "";
      }
      var ros = new ROSLIB.Ros({
        url: process.env.VUE_APP_ROS_SERVER_URL
      });
      var width = document.getElementById("map").offsetWidth;
      var height = document.getElementById("map").offsetHeight;
      this.viewer = new ROS2D.Viewer({
        divID: "map",
        width: width,
        height: height,
        antialias: true
      });
      let gridClient = new ROS2D.OccupancyGridClient({
        ros: ros,
        rootObject: this.viewer.scene,
        topic: "/map",
        continuous: true,
        withOrientation: true
      });

      var zoomView = new ROS2D.ZoomView({
        rootObject: this.viewer.scene,
        minScale: 5,
        maxScale: 20
      });

      var panView = new ROS2D.PanView({
        rootObject: this.viewer.scene
      });

      // Scale the canvas to fit to the map
      gridClient.on("change", () => {
        this.viewer.scaleToDimensions(
          gridClient.currentGrid.width,
          gridClient.currentGrid.height
        );
        this.viewer.shift(
          gridClient.currentGrid.pose.position.x,
          gridClient.currentGrid.pose.position.y
        );
        zoomView.startZoom(
          this.viewer.scene.canvas.offsetWidth / 2,
          this.viewer.scene.canvas.offsetHeight / 2
        );
        zoomView.zoom(this.mapZoom);

        handleMouseEvent();
      });
      var topics = [];

      const handleMouseEvent = () => {
        // IE9, Chrome, Safari, Opera
        // Touch library https://hammerjs.github.io/recognizer-swipe/
        this.viewer.scene.canvas.addEventListener(
          "mousewheel",
          MouseWheelHandler,
          false
        );
        this.viewer.scene.canvas.addEventListener(
          "mousedown",
          e => {
            var mousePos = this.getMousePos(this.viewer.scene.canvas, e);
            panView.startPan(mousePos.x, mousePos.y);
          },
          false
        );
        this.viewer.scene.canvas.addEventListener(
          "DOMMouseScroll",
          e => {
            var mousePos = this.getMousePos(this.viewer.scene.canvas, e);
            panView.startPan(mousePos.x, mousePos.y);
          },
          false
        );
        this.viewer.scene.canvas.addEventListener(
          "mouseup",
          e => {
            var mousePos = this.getMousePos(this.viewer.scene.canvas, e);
            panView.pan(mousePos.x, mousePos.y);
            //zoomView.startZoom(mousePos.x, mousePos.y);
          },
          false
        );
      };

      let scale = 1;

      const MouseWheelHandler = e => {
        // cross-browser wheel delta
        scale += e.deltaY * -0.01;

        // var mousePos = this.getMousePos(this.viewer.scene.canvas, e);
        // zoomView.startZoom(mousePos.x, mousePos.y);

        // Restrict scale
        scale = Math.min(Math.max(4, scale), 20);
        zoomView.zoom(scale);
        console.log(scale);

        e.preventDefault();
        return false;
      };

      var createFunc = function(handlerToCall, discriminator, robotMarker) {
        return discriminator.subscribe(function(pose) {
          robotMarker.x = pose.pose.pose.position.x;
          robotMarker.y = -pose.pose.pose.position.y;
          var quaZ = pose.pose.pose.orientation.z;
          var degreeZ = 0;
          if (quaZ >= 0) {
            degreeZ = (quaZ / 1) * 180;
          } else {
            degreeZ = (-quaZ / 1) * 180 + 180;
          }
          robotMarker.rotation = -degreeZ + 35;
          //TODO https://github.com/RobotWebTools/ros2djs/issues/39#issuecomment-621831740
        });
      };

      // Setup the map client.
      var robotMarker = new ROS2D.NavigationArrow({
        size: 0.25,
        strokeSize: 0.05,
        pulse: true,
        fillColor: createjs.Graphics.getRGB(121, 155, 41, 0.65)
      });

      var poseTopic = new ROSLIB.Topic({
        ros: ros,
        name: "/map/pose/stamped",
        messageType: "geometry_msgs/PoseWithCovarianceStamped"
      });
      topics.push(poseTopic);
      createFunc("subscribe", poseTopic, robotMarker);

      console.log("attaching marker...");
      gridClient.rootObject.addChild(robotMarker);

      this.$emit("initMap", this.viewer);
    },

    // convert the given global Stage coordinates to ROS coordinates
    globalToRos(viewer, x, y) {
      var rosX = (x - viewer.x) / viewer.scaleX;
      var rosY = (viewer.y - y) / viewer.scaleY;
      return new ROSLIB.Vector3({
        x: rosX,
        y: rosY
      });
    },

    // convert the given ROS coordinates to global Stage coordinates
    rosToGlobal(viewer, pos) {
      var x = pos.x * viewer.scaleX + viewer.x;
      var y = pos.y * viewer.scaleY + viewer.y;
      return {
        x: x,
        y: y
      };
    },
    getMousePos(canvas, evt) {
      var rect = canvas.getBoundingClientRect();
      return {
        x: evt.clientX - rect.left,
        y: evt.clientY - rect.top
      };
    }
  }
};
</script>
<style scoped>
#map {
  cursor: grab;
}
</style>